import React from 'react';
import logo from '../../assets/jtlogo.jpeg';
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { FaSquareTwitter } from "react-icons/fa6";
import Home from "../../pages/Jinrai/Home.js";
import About from "../../pages/Jinrai/About.js";
import Portfolio from "../../pages/Jinrai/Portfolio.js";
import Clients from "../../pages/Jinrai/Clients.js";
import Job from "../../pages/Jinrai/Job.js";


const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[--bg-color] shadow dark:bg-gray-900 sm:pt-0 pt-8 px-8" role="contentinfo">
      <div className="w-full max-w-screen-xl mx-auto py-8">
        <div className="md:flex md:justify-between gap-6 justify-start align-top items-start">

          {/*  */}
          <div onClick={() => navigate('/')} className='w-full text-center flex flex-col ustify-center align-middle cursor-pointer'>
            <div className='w-full flex justify-center'>
            <img src={logo} className="h-20 w-20 rounded-lg" alt="Jinrai Technologies Logo" />
            </div>
            <div className="self-center text-lg text-white font-semibold whitespace-nowrap dark:text-white">
              Jinrai Technologies Private Limited
            </div>
          </div>

          <div className='w-full md:text-start text-white text-center mb-6 md:mb-0'>
            <h3 className='text-lg font-semibold uppercase'>Quick Link</h3>
            <ul>
              <li><a onClick={() => navigate('/')} className='hover:text-yellow-300 cursor-pointer'>Home</a></li>
              <li><a onClick={() => navigate('/about')} className='hover:text-yellow-300 cursor-pointer'>About</a></li>
              <li><a onClick={() => navigate('/portfolio')} className='hover:text-yellow-300 cursor-pointer'>Portfolio</a></li>
              <li><a onClick={() => navigate('/clients')} className='hover:text-yellow-300 cursor-pointer'>Clients</a></li>
              <li><a onClick={() => navigate('/job')} className='hover:text-yellow-300 cursor-pointer'>Job</a></li>
              <li><a onClick={() => navigate('/contact')} className='hover:text-yellow-300 cursor-pointer'>Contact</a></li>
            </ul>
          </div>
          
          <div className='w-full md:text-start text-white text-center mb-6 md:mb-0'>
            <h3 className='text-lg font-semibold uppercase'>Our Products</h3>
            <ul>
              <li><a href='https://crm.jinraitech.com/' target="_blank" className='hover:text-yellow-300'>CRM</a></li>
              <li><a href='https://contactcard.jinraitech.com/' target="_blank" className='hover:text-yellow-300'>Contact Card</a></li>
            </ul>
          </div>
          
          <div className='w-full md:text-start text-white text-center mb-6 md:mb-0'>
            <h3 className='text-lg font-semibold uppercase'>Other Link</h3>
            <ul>
              <li><a onClick={() => navigate('/terms-conditions')} className='hover:text-yellow-300 cursor-pointer'>Terms & Conditions</a></li>
              <li><a onClick={() => navigate('/privacy-policy')} className='hover:text-yellow-300 cursor-pointer'>Privacy Policy</a></li>
              <li><a onClick={() => navigate('/cancellation-policy')} className='hover:text-yellow-300 cursor-pointer'>Cancellation and Refund Policy</a></li>
              <div className="text-white w-full text-xl flex flex-row gap-5 mt-4 md:text-start text-center">
                  <a href="https://linkedin.com/company/jinraitech" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Profile">
                    <FaLinkedin className="cursor-pointer" />
                  </a>
                  <a href="https://facebook.com/jinraitech" target="_blank" rel="noopener noreferrer" aria-label="Facebook Profile">
                    <FaFacebook className="cursor-pointer" />
                  </a>
                  <a href="https://twitter.com/Jinraitech" target="_blank" rel="noopener noreferrer" aria-label="Twitter Profile">
                    <FaSquareTwitter className="cursor-pointer" />
                  </a>
                </div>
            </ul>
          </div>

          {/*  */}
          
          {/* Logo and Company Name */}
          {/* <div onClick={() => navigate('/')} className="flex flex-col flex-wrap justify-center items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse" role="link" aria-label="Homepage">
            <img src={logo} className="h-20 rounded-lg" alt="Jinrai Technologies Logo" />
            
            <span className="self-center text-lg text-white font-semibold whitespace-nowrap dark:text-white">
              Jinrai Technologies Private Limited
            </span>
          </div> */}

          {/* Navigation Links */}
          {/* <nav>
            <ul className="md:flex md:flex-wrap md:items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
              <li className="text-center">
                <a onClick={() => navigate('/about')} className="hover:underline me-4 md:me-6 text-white text-center cursor-pointer" aria-label="About Us Page">About</a>
              </li>
              <li className="text-center">
                <a onClick={() => navigate('/portfolio')} className="hover:underline me-4 md:me-6 text-white text-center cursor-pointer" aria-label="Portfolio Page">Portfolio</a>
              </li>

              <li className="sm:mt-8 ">
                <div onClick={() => navigate('/contact')} className="hover:underline me-4 md:me-6 text-white text-center cursor-pointer" aria-label="Contact Us Page">Contact with Us</div>
                <div className="text-white text-xl flex flex-row md:justify-around justify-center md:gap-0 gap-4 mt-3">
                  <a href="https://linkedin.com/company/jinraitech" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Profile">
                    <FaLinkedin className="cursor-pointer" />
                  </a>
                  <a href="https://facebook.com/jinraitech" target="_blank" rel="noopener noreferrer" aria-label="Facebook Profile">
                    <FaFacebook className="cursor-pointer" />
                  </a>
                  <a href="https://twitter.com/Jinraitech" target="_blank" rel="noopener noreferrer" aria-label="Twitter Profile">
                    <FaSquareTwitter className="cursor-pointer" />
                  </a>
                </div>
              </li>
            </ul>
          </nav> */}
        </div>

        {/* Separator */}
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />

        {/* Copyright Information */}
        <div className="md:flex md:justify-center text-sm text-white text-center dark:text-gray-400">
          <div className="pr-1">© 2024</div>
          <span className="underline">Jinrai Technologies Private Limited.</span>
          <div className="pl-1"> All Rights Reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
